export default "__VITE_ASSET__BftvzIlu__"